import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__solicitacoes_endpoints} from "@components/solicitacoes/endpoints/__solicitacoes_endpoints.ts";
import {ICreateSolicitacaoDto} from "@components/solicitacoes/dto/input/ICreateSolicitacaoDto.ts";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {CreateRefLinkDto} from "@components/solicitacoes/itens/dto/CreateRefLinkDto.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";

export function useSolicitacao() {
    const {Get} = useApi()

    const confirmarOrcamento = async (data: { idOrcamento: number }) => {
        return Get(__solicitacoes_endpoints.v2.orcamento.confirmar(data))
    }
    const cancelarOrcamento = async (data: { idOrcamento: number, motivo: string }) => {
        return Get(__solicitacoes_endpoints.v2.orcamento.cancelar(data))
    }
    const createSolicitacao = (data: ICreateSolicitacaoDto) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao.create({data: data}));
    }
    const transferirSolicitacao = (data: { idSolicitacao: number, idNovoSolicitante: number }) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao['transferir']({data: data}));
    }
    const finalizarSolicitacao = (data: { idSolicitacao: number }) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao['finalizar-solicitacao']({data: data}));
    }
    const getValoresSolicitacao = (data: { idSolicitacao: number }) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao['get-valores']({id: data.idSolicitacao}));
    }
    const getLogsSolicitacao = (data: IDataDto<{ idSolicitacao: number }>) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao['get-logs'](data));
    }
    const getReferenciasItens = (data: IDataDto<{ idItem: number }>) => {
        return Get(__solicitacoes_endpoints.v2.itens["get-referencias"](data));
    }
    const createReferenciaItem = (data: CreateRefLinkDto) => {
        return Get(__solicitacoes_endpoints.v2.itens["add-referencia"]({data: data}));
    }
    const getItens = (data: {
        idSolicitacao: number,
        contaReferencias?: boolean,
        contaOrcamentos?: boolean
    }, pagination: IPagination) => {
        return Get(__solicitacoes_endpoints.v2.solicitacao['get-itens']({data, pagination}));
    }


    return {
        confirmarOrcamento: confirmarOrcamento,
        cancelarOrcamento: cancelarOrcamento,
        finalizarSolicitacao: finalizarSolicitacao,
        createSolicitacao: createSolicitacao,
        getValoresSolicitacao: getValoresSolicitacao,
        transferirSolicitacao: transferirSolicitacao,
        getLogsSolicitacao: getLogsSolicitacao,
        getReferenciasItens: getReferenciasItens,
        createReferenciaItem: createReferenciaItem,
        getItens: getItens,
    }
}